import styles from './OficinaHowItWorks.module.scss';
import PhotoCarousel from '../PhotoCarousel';
import ClockIcon from '../../images/oficinas-clock.svg';
import GroupIcon from '../../images/oficinas-group.svg';
import ChildrenIcon from '../../images/oficinas-children.svg';
import ChairIcon from '../../images/oficinas-chair.svg';
import ComoFunciona from '../../images/como-funciona.svg';

function OficinasHowItWorks() {
  return <div className={styles.container}>
    <div className={styles.content}>
      <PhotoCarousel background="transparent" />
      <div className={styles.info}>
        <h2><img src={ComoFunciona} alt="Como funciona" /></h2>

        <div className={styles.infoGrid}>
          <div className={styles.infoItem}>
            <div className={styles.icon}><img className={styles.clockIcon} src={ClockIcon} alt="Duration" /></div>
            <p>2 - 3 horas de duração</p>
          </div>

          <div className={styles.infoItem}>
            <div className={styles.icon}><img className={styles.childrenIcon} src={ChildrenIcon} alt="Class size" /></div>
            <p>6 a 17 anos de idade</p>
          </div>

          <div className={styles.infoItem}>
            <div className={styles.icon}><img className={styles.groupIcon} src={GroupIcon} alt="Age range" /></div>
            <p>De 20 a 500 aluno(a)s<br />por turma <span>(a depender do espaço)</span></p>
          </div>

          <div className={styles.infoItem}>
            <div className={styles.icon}><img className={styles.chairIcon} src={ChairIcon} alt="School type" /></div>
            <p>Em escolas públicas<br />ou privadas.</p>
          </div>
        </div>
      </div>
    </div>
         </div>;
}

export default OficinasHowItWorks;
